import React, { useEffect, useState } from "react";
import { Backdrop, Button, Card, CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";

import GetDetailsAns from "./getDetailsAns";
import { isEmptyDash } from "../../constant";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { onboardingServices } from "../../services/onboardingServices";

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const sap_head = {
  paddingLeft: "20px",
  marginBottom: "6px",
  fontWeight: "700"
};

function FinancialTaxStep2({ data, viewUrlData, vendorId, changeScreen, latestStepId }) {
  const [isEditModal, setIsEditModal] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalData, setModalData] = React.useState({ fields: [] });
  const [financeData, setFinanceData] = React.useState({ fieldsWithResponses: [] });
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const viewMedia = (data) => {
    viewUrlData(data);
  };

  useEffect(() => {
    setFinanceData(data);
  }, [data]);

  const openEditModal = (ele, index) => {
    let obj = { ...ele };
    obj.index = index
    setModalData(obj);
    setIsEditModal(true);
  }

  const handleCloseModal = () => {
    setIsEditModal(false);
    setModalData({ fields: [] });
  }

  const [dependentOptionId, setdependentOptionId] = React.useState("");
  const [taxcodeId, setTaxcodeId] = useState("");

  const clearField = (secIndex) => {
    let financeDataInit = _.cloneDeep(financeData);
    for (let i = 0; i < financeDataInit.fieldsWithResponses[secIndex].fields.length; i++) {
      if (financeDataInit.fieldsWithResponses[secIndex].fields[i].type == "Dropdown") {
        financeDataInit.fieldsWithResponses[secIndex].fields[i].response.optionId = "";        
      }
      if (financeDataInit.fieldsWithResponses[secIndex].fields[i].type == "MultiSelect") {
        financeDataInit.fieldsWithResponses[secIndex].fields[i].response.optionIds = "";        
      }
    }  
    setFinanceData(financeDataInit);  
  }

  const handleChange = (value, secIndex, modalEle, i) => {
    let financeDataInit = _.cloneDeep(financeData);
    financeDataInit.fieldsWithResponses[secIndex].fields[i].response.optionIds = value;
    setFinanceData(financeDataInit);
  };

  const onSelectChange = (value, secIndex, modalEle, i) => {    
    let financeDataInit = _.cloneDeep(financeData);
    financeDataInit.fieldsWithResponses[secIndex].fields[i].response.optionId = value;

    if (modalEle?.uniqueName === 'taxType1') {
      const selected = modalEle?.options?.find(option => option._id === value);
      setdependentOptionId(selected?.dependentOptionId)
      for (let item of financeDataInit.fieldsWithResponses[secIndex]?.fields[2]?.options) {
        if (item?._id === dependentOptionId) {
          setTaxcodeId(item)
        }
      }
      financeDataInit.fieldsWithResponses[secIndex].fields[i + 1].response.optionId = selected?.dependentOptionId;
    }

    if (modalEle?.uniqueName === 'taxType2') {
      const selected = modalEle?.options?.find(option => option._id === value);
      setdependentOptionId(selected?.dependentOptionId)
      for (let item of financeDataInit.fieldsWithResponses[secIndex]?.fields[6]?.options) {
        if (item?._id === dependentOptionId) {
          setTaxcodeId(item)
        }
      }
      financeDataInit.fieldsWithResponses[secIndex].fields[i + 1].response.optionId = selected?.dependentOptionId;
    }
    setFinanceData(financeDataInit);
    // setModalData(modalDataInit);
  };

  const handleSubmit = (secIndex) => {
    // let progressStepInit = _.cloneDeep(progressStep);
    let modalDataInit = _.cloneDeep(financeData.fieldsWithResponses[secIndex]);
    let isValid = true;
    let dataArr = [];

    // let secLength = modalDataInit?.lastStepData?.sections.length;
    for ( let i = 0; i < modalDataInit?.fields.length; i++ ) {
      if ( modalDataInit?.fields[i].required == true && modalDataInit?.fields[i].type == "Dropdown" &&
        isEmptyDash( modalDataInit?.fields[i]?.response?.optionId )) {
        isValid = false;
      } 
      else if ( modalDataInit?.fields[i].required == true &&  modalDataInit?.fields[i].type == "MultiSelect" && isEmptyDash( modalDataInit?.fields[i]?.response?.optionIds.length)) {
        isValid = false;
      } else {
        if (modalDataInit?.fields[i].type == "MultiSelect" ) {
          dataArr.push({
            questionId: modalDataInit?.fields[i]._id,
            optionIds: modalDataInit?.fields[i]?.response?.optionIds,
          });
        }

        if ( modalDataInit?.fields[i].type == "Dropdown" ) {
          dataArr.push({
            questionId: modalDataInit?.fields[i]._id,
            optionId: (modalDataInit?.fields[i]?.response?.optionId == "null") ? null : modalDataInit?.fields[i]?.response?.optionId,
          });
        }
      }
    }
    let stepId = data?.vendorStatus === 'SAP Creation Failed' ? data?.steps[1]?._id : latestStepId;
    if (isValid) {
      let obj = {
        "vendorId": vendorId,
        "stepId": stepId,
        // "stepId": latestStepId,
        "formData": {
          "sectionId": modalDataInit?.sectionId,
          "fields": [...dataArr],
        },
      };

      setIsLoading(true);
      onboardingServices
        .submitLastStepDetails(obj)
        .then(function (response) {
          // getFormProgress(props?.vendorId);
          setIsEditModal(false);
          openAlert(true, "success", `${response?.data?.message}`);
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      openAlert(true, "error", `Please fill all required fields.`);
    }
  };


  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  return (
    <>
      <div className="">
        <div className="text-centers">
          {financeData?.fieldsWithResponses.map((ele, idx) => <>
            {(ele?.isModal == false) && <>
              <h5 className="vendor-details-sec-head">
                {ele?.sectionName}
              </h5>

              {(ele?.editAccess != true) && <Card className="vendor-details-card">
                <div className="">
                  <div className="row ">
                    {ele?.fields.map((childEle, j) => <>
                      {(childEle?.display == true) && <div className="col-sm-6">
                        <div className="row vendor-details-ele-row">
                          <div className="col-sm-5">
                            <h6 className="name_information_business_vendor_listing">
                              {childEle?.name}:
                            </h6>
                          </div>
                          <div className="col-sm-7 text-secondary lets_Technology_vendorlist">
                            <GetDetailsAns data={childEle} viewMedia={viewMedia} />
                          </div>
                        </div>
                      </div>}
                    </>)}
                  </div>
                </div>
              </Card>}

              {(ele?.editAccess == true) && <>
                <div class="row">
                  {ele?.fields.map((modalEle, i) => <>
                    {ele?.sectionName === 'SAP Taxation Fields' && (
                      <>
                        {i === 0 && <div className="col-sm-12" style={sap_head}>Invoice</div>}
                        {i === 4 && <div className="col-sm-12" style={sap_head}>Payment</div>}
                      </>
                    )}
                    {(modalEle?.type == "String") && <>
                      <div className=" col-sm-3">
                        <div className="lets_select_sme modal-sec-div">
                          <label className="sap_text_blcok">
                            {modalEle?.name}
                            {(modalEle?.required == true) && <span className="required">*</span>}
                          </label>
                          <input
                            type="text"
                            id="contactName"
                            className="form-control form_h_modal"
                            placeholder="Enter Employee ID"
                            required=""
                          // value={employeeId}
                          // onChange={(e) => {
                          //   setemployeeId(e.target.value);
                          // }}
                          />
                          <div className="error-message" id="contactNameError"></div>
                        </div>
                      </div>
                    </>}
                    {(modalEle?.type == "Dropdown") && <>
                      <div className={modalEle?.name === 'Reconciliation Account' ? "col-sm-4" : "col-sm-3"} >
                        <div className="lets_select_sme modal-sec-div" >
                          <label className="sap_text_blcok">
                            {modalEle?.name}
                            {(modalEle?.required === true) && <span className="required">*</span>}
                          </label>
                          <select
                            id="onboardingType"
                            className="form-select employeecreations_panel "
                            aria-label="Default select example"
                            value={modalEle?.response?.optionId}
                            onChange={(e) => onSelectChange(e.target.value, idx, modalEle, i)}
                            disabled={modalEle?.editAccess === false}
                            style={{ height: "42px" }}
                          >
                            <option value={"null"}>Please Select</option>
                            {modalEle?.options?.map((optionData) => (
                              <option key={optionData?._id} value={optionData?._id}>
                                {optionData?.optionName}
                              </option>
                            ))}
                          </select>
                          <div className="error-message" id="contactNameError"></div>
                        </div>
                      </div>
                    </>}
                    {(modalEle?.type == "MultiSelect") && <>
                      <div className="col-sm-4">
                        <div className="lets_select_sme modal-sec-div">
                          <label className="sap_text_blcok">
                            {modalEle?.name}
                            {(modalEle?.required == true) && <span className="required">*</span>}
                          </label>
                          <FormControl className="seclected_form_detail1ses12 d-flex">
                            <Select
                              class="form-select seclected_form_detail1ses12"
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={isEmptyDash(modalEle?.response?.optionIds) ? [] : modalEle?.response?.optionIds}
                              onChange={(e) => handleChange(e.target.value, idx, modalEle, i)}
                              placeholder="Please Select"
                              // input={<OutlinedInput label="Tag" />}
                              renderValue={(selected) => {
                                const selectedNames = selected.map(id => {
                                  const option = modalEle?.options.find(opt => opt._id === id);
                                  return option ? option.optionName : id;
                                });
                                return selectedNames.join(", ")
                              }}
                              MenuProps={MenuProps}
                            // disabled={modalEle?.editAccess == false}
                            >
                              {modalEle?.options.map(
                                (multiSelectData) => (
                                  <MenuItem
                                    key={multiSelectData?._id}
                                    value={multiSelectData?._id}
                                    disabled={modalEle?.editAccess === false}
                                  >
                                    <Checkbox
                                      checked={isEmptyDash(modalEle?.response?.optionIds) ? false : modalEle?.response?.optionIds.indexOf(multiSelectData?._id) > -1
                                      }
                                    />
                                    <ListItemText
                                      primary={multiSelectData?.optionName}
                                    />
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </FormControl>
                          <div className="error-message" id="contactNameError"></div>
                        </div>
                      </div>
                    </>}
                  </>)}

                  {(ele?.editAccess == true) && <div className="clear_btn_status" style={{justifyContent: "right"}}>
                      
                      <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={() => handleSubmit(idx)}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        data-dismiss="modal"
                        onClick={() => clearField(idx)}
                      >
                        Clear
                      </button>
                  </div>}
                </div>
              </>}
              


            </>}
            
              <div className="div-details-modal-btn">
                {(ele?.isModal == true) && <><button className="" onClick={() => openEditModal(ele, idx)} >
                  {ele?.sectionName}
                </button></>}
                {(idx == financeData?.fieldsWithResponses?.length -1) && <button className="div-details-modal-btn" onClick={() => changeScreen(true)}>
                    View Progress
                  </button>}
              </div>
            
          </>)}
        </div>
        <Modal
          open={isEditModal}
          // onClose={() => setOpenVendorcreateEmp(false)}
          onClose={() => handleCloseModal()}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={style}
            className="vendor-details-modal"
          >
            <div className="modal-header">
              <h5 className="modal-titles" id="uploadexcelfileLabel">
                {modalData?.sectionName}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => handleCloseModal()}
              ></button>
            </div>
            <div className="modal-body">
              <div id="financeForm" className="row">
                <div class="row">
                  {modalData?.fields.map((modalEle, i) => <>
                    {modalData?.sectionName === 'SAP Taxation Fields' && (
                      <>
                        {i === 0 && <div className="col-sm-12" style={sap_head}>Invoice</div>}
                        {i === 4 && <div className="col-sm-12" style={sap_head}>Payment</div>}
                      </>
                    )}
                    {(modalEle?.type == "String") && <>
                      <div className=" col-sm-3">
                        <div className="lets_select_sme modal-sec-div">
                          <label className="sap_text_blcok">
                            {modalEle?.name}
                            {(modalEle?.required == true) && <span className="required">*</span>}
                          </label>
                          <input
                            type="text"
                            id="contactName"
                            className="form-control form_h_modal"
                            placeholder="Enter Employee ID"
                            required=""
                          // value={employeeId}
                          // onChange={(e) => {
                          //   setemployeeId(e.target.value);
                          // }}
                          />
                          <div className="error-message" id="contactNameError"></div>
                        </div>
                      </div>
                    </>}
                    {(modalEle?.type == "Dropdown") && <>
                      <div className={modalEle?.name === 'Reconciliation Account' ? "col-sm-4" : "col-sm-3"} >
                        <div className="lets_select_sme modal-sec-div" >
                          <label className="sap_text_blcok">
                            {modalEle?.name}
                            {(modalEle?.required === true) && <span className="required">*</span>}
                          </label>
                          <select
                            id="onboardingType"
                            className="form-select employeecreations_panel "
                            aria-label="Default select example"
                            value={modalEle?.response?.optionId}
                            onChange={(e) => onSelectChange(e.target.value, modalData?.index, modalEle, i)}
                            disabled={modalEle?.editAccess === false}
                            style={{ height: "42px" }}
                          >
                            <option value={"null"}>Please Select</option>
                            {modalEle?.options?.map((optionData) => (
                              <option key={optionData?._id} value={optionData?._id}>
                                {optionData?.optionName}
                              </option>
                            ))}
                          </select>
                          <div className="error-message" id="contactNameError"></div>
                        </div>
                      </div>
                    </>}
                    {(modalEle?.type == "MultiSelect") && <>
                      <div className="col-sm-4">
                        <div className="lets_select_sme modal-sec-div">
                          <label className="sap_text_blcok">
                            {modalEle?.name}
                            {(modalEle?.required == true) && <span className="required">*</span>}
                          </label>
                          <FormControl className="seclected_form_detail1ses12 d-flex">
                            <Select
                              class="form-select seclected_form_detail1ses12"
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={isEmptyDash(modalEle?.response?.optionIds) ? [] : modalEle?.response?.optionIds}
                              onChange={(e) => handleChange(e.target.value, modalData?.index, modalEle, i)}
                              placeholder="Please Select"
                              // input={<OutlinedInput label="Tag" />}
                              renderValue={(selected) => {
                                const selectedNames = selected.map(id => {
                                  const option = modalEle?.options.find(opt => opt._id === id);
                                  return option ? option.optionName : id;
                                });
                                return selectedNames.join(", ")
                              }}
                              MenuProps={MenuProps}
                            // disabled={modalEle?.editAccess == false}
                            >
                              {modalEle?.options.map(
                                (multiSelectData) => (
                                  <MenuItem
                                    key={multiSelectData?._id}
                                    value={multiSelectData?._id}
                                    disabled={modalEle?.editAccess === false}
                                  >
                                    <Checkbox
                                      checked={isEmptyDash(modalEle?.response?.optionIds) ? false : modalEle?.response?.optionIds.indexOf(multiSelectData?._id) > -1
                                      }
                                    />
                                    <ListItemText
                                      primary={multiSelectData?.optionName}
                                    />
                                  </MenuItem>
                                )
                              )}
                            </Select>
                          </FormControl>
                          <div className="error-message" id="contactNameError"></div>
                        </div>
                      </div>
                    </>}
                  </>)}
                </div>
                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-dismiss="modal"
                    onClick={() => handleCloseModal()}
                  >
                    Close
                  </button>
                  {(modalData?.editAccess == true) && <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>}
                </div>
              </div>
            </div>
          </Box>
        </Modal>
        <AlertComponent
          alertComponent={alertComponent}
          handleClose={handleCloseAlert}
        />
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div >
    </>
  );
}

export default FinancialTaxStep2;
